import React, { useEffect, useState } from "react";

const PrevArrow = ({ arrow }) => {
  const { locale } = useState();
  const [arrowOpacity, setArrowOpacity] = useState("");

  useEffect(() => {
    setArrowOpacity(
      locale === "ar"
        ? arrow.isEnd
          ? "0.3"
          : "1"
        : arrow.isBeginning
        ? "0.3"
        : "1"
    );

    console.log(arrow);
  }, [locale, arrow]);
  return (
    <div>
      <svg
        width="15.63"
        height="12.86"
        viewBox="0 0 26 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity={arrowOpacity}
          d="M5.86174 10.5473C5.98441 10.5473 6.11666 10.5473 6.23933 10.5473C14.8672 10.5473 16.2777 10.5473 24.9056 10.5473C25.859 10.5473 26.4631 10.9771 26.5858 11.7422C26.7085 12.4729 26.0949 13.195 25.2831 13.2724C25.1226 13.2896 24.9527 13.281 24.7923 13.281C16.1927 13.281 14.8295 13.281 6.22993 13.281C6.10726 13.281 5.98441 13.281 5.84276 13.281C5.88055 13.4446 6.00322 13.4961 6.08817 13.5821C8.60859 15.8859 11.1385 18.181 13.6683 20.4848C14.5367 21.2757 14.263 22.4878 13.1397 22.823C12.5355 23.0037 12.0069 22.8662 11.5538 22.4536C10.8175 21.7831 10.0907 21.1212 9.35437 20.4507C6.6357 17.975 3.91706 15.4993 1.1984 13.0236C0.396026 12.2929 0.405398 11.5364 1.2078 10.8058C4.64385 7.67683 8.07984 4.54784 11.5159 1.41883C11.9501 1.02343 12.4408 0.799896 13.0733 0.945976C14.2061 1.21245 14.6121 2.44165 13.8097 3.21532C13.2622 3.74817 12.6769 4.25539 12.1106 4.77114C10.0998 6.60205 8.08915 8.43304 6.07849 10.2554C5.99354 10.3328 5.88975 10.3843 5.79537 10.4445C5.81427 10.4789 5.84254 10.5133 5.86174 10.5473Z"
          fill="#010140"
        />
      </svg>
    </div>
  );
};

export default PrevArrow;
